// import React, { useState, useEffect } from "react";
// import { weatherDescriptions } from "../utils/weatherDescriptions.js";

// const WeatherComponent = ({ forecasts = [], textColor = "white", fontFamily = "Arial" }) => {
//   const [latestForecast, setLatestForecast] = useState(null);

//   useEffect(() => {
//     const updateForecasts = () => {
//       if (!forecasts || forecasts.length === 0) return;

//       const now = new Date();

//       // Find the forecast closest to the current time
//       const closestForecast = forecasts.reduce((prev, curr) => {
//         const prevDate = new Date(prev.date);
//         const currDate = new Date(curr.date);
//         return Math.abs(currDate - now) < Math.abs(prevDate - now)
//           ? curr
//           : prev;
//       });

//       setLatestForecast(closestForecast);
//     };

//     updateForecasts();

//     const interval = setInterval(updateForecasts, 20 * 60 * 1000);

//     return () => clearInterval(interval);
//   }, [forecasts]);

//   const translateWeatherDescription = (description) => {
//     return weatherDescriptions[description] || description;
//   };

//   if (!latestForecast) {
//     return <div>No weather data available</div>;
//   }

//   return (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "flex-end",
//         color: textColor, // Apply the textColor prop
//         width: "100%",
//         textAlign: "center",
//         fontFamily: fontFamily,
//       }}
//     >
//       <img
//         src={`http://openweathermap.org/img/wn/${latestForecast.icon}.png`}
//         alt={latestForecast.description}
//         style={{ width: "40px", height: "40px" }}
//       />
//       <p style={{ marginRight: "0px" }}>
//         {Math.round(latestForecast.temperature)}°C
//       </p>
//       <p style={{ marginRight: "10px" }}>
//         {translateWeatherDescription(latestForecast.description)}
//       </p>
//     </div>
//   );
// };

// export default WeatherComponent;


import React, { useMemo } from "react";
import { weatherDescriptions } from "../utils/weatherDescriptions.js";

const WeatherComponent = ({
  forecasts = [],
  textColor = "white",
  fontFamily = "Arial",
}) => {
  // 1. תאריך היום
  const today = new Date();

  // 2. סינון כל התחזיות שמיועדות להיום
  const todaysForecasts = useMemo(() => {
    return forecasts.filter((f) => {
      const d = new Date(f.date);
      return (
        d.getDate() === today.getDate() &&
        d.getMonth() === today.getMonth() &&
        d.getFullYear() === today.getFullYear()
      );
    });
  }, [forecasts, today]);

  // 3. חישוב מינימום ומקסימום מתוך רשימת התחזיות של היום
  const { minTemp, maxTemp } = useMemo(() => {
    if (todaysForecasts.length === 0) {
      return { minTemp: null, maxTemp: null };
    }
    const temps = todaysForecasts.map((f) => f.temperature);
    return {
      minTemp: Math.min(...temps),
      maxTemp: Math.max(...temps),
    };
  }, [todaysForecasts]);

  // 4. בוחרים אייקון ותיאור מהתחזית הקרובה ביותר (לפי קוד קיים)
  const latestForecast = useMemo(() => {
    if (todaysForecasts.length === 0) return null;
    const now = new Date();
    return todaysForecasts.reduce((prev, curr) => {
      const prevDiff = Math.abs(new Date(prev.date) - now);
      const currDiff = Math.abs(new Date(curr.date) - now);
      return currDiff < prevDiff ? curr : prev;
    });
  }, [todaysForecasts]);

  const translateWeatherDescription = (description) =>
    weatherDescriptions[description] || description;

  if (!latestForecast || minTemp === null) {
    return <div>No weather data available</div>;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        color: textColor,
        width: "100%",
        textAlign: "center",
        fontFamily,
      }}
    >
      <img
        src={`http://openweathermap.org/img/wn/${latestForecast.icon}.png`}
        alt={latestForecast.description}
        style={{ width: "40px", height: "40px" }}
      />
      <p style={{ margin: "0 10px" }}>
        {`${Math.round(minTemp)}°C – ${Math.round(maxTemp)}°C`}
      </p>
      <p style={{ marginRight: "10px" }}>
        {translateWeatherDescription(latestForecast.description)}
      </p>
    </div>
  );
};

export default WeatherComponent;
